export default __webpack_public_path__ + "static/media/resendGray_icon.ee6ff5f2.svg";